import { render, staticRenderFns } from "./AwardPage.vue?vue&type=template&id=0d21cd0d&scoped=true"
import script from "./AwardPage.vue?vue&type=script&lang=ts"
export * from "./AwardPage.vue?vue&type=script&lang=ts"
import style0 from "./AwardPage.vue?vue&type=style&index=0&id=0d21cd0d&prod&lang=scss&scoped=true"
import style1 from "./AwardPage.vue?vue&type=style&index=1&id=0d21cd0d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d21cd0d",
  null
  
)

export default component.exports